"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encode = function (buffer) {
    var bufs = [];
    var i = 0;
    while (i < buffer.length) {
        var byte = buffer[i];
        // if last 1 byte remaining
        if (i + 1 >= buffer.length) {
            var length_1 = 1;
            var buf = Buffer.from([length_1 - 1]);
            bufs.push(buf);
            bufs.push(buffer.slice(i, buffer.length));
            break;
        }
        var repeat = byte === buffer[i + 1];
        if (repeat) {
            // literal repeated
            var j = i + 1;
            var length_2 = 2;
            while (++j < buffer.length && byte === buffer[j] && length_2 < 128) {
                length_2++;
            }
            var buf = Buffer.from([1 - length_2, byte]);
            bufs.push(buf);
            i = j;
        }
        else {
            // no literal repeated
            var j = i + 1;
            var length_3 = 2;
            var prev = buffer[j];
            while (++j < buffer.length && prev !== buffer[j] && length_3 < 128) {
                length_3++;
                prev = buffer[j];
            }
            // rollback index if detect repeat
            if (prev === buffer[j]) {
                j--;
                length_3--;
            }
            var buf = Buffer.from([length_3 - 1]);
            bufs.push(buf);
            bufs.push(buffer.slice(i, j));
            i = j;
        }
    }
    return Buffer.concat(bufs);
};
exports.decode = function (buffer) {
    var bufs = [];
    var i = 0;
    while (i < buffer.length) {
        var byte = buffer.readInt8(i);
        // -128 -> skip
        if (byte === -128) {
            i++;
            continue;
        }
        var buf = void 0;
        if (byte < 0) {
            // -1 to -127 -> one byte of data repeated (1 - byte) times
            var length_4 = 1 - byte;
            buf = Buffer.alloc(length_4, buffer.slice(i + 1, i + 2));
            i += 2;
        }
        else {
            // 0 to 127 -> (1 + byte) literal bytes
            var length_5 = 1 + byte;
            buf = buffer.slice(i + 1, i + 1 + length_5);
            i += 1 + length_5;
        }
        bufs.push(buf);
    }
    return Buffer.concat(bufs);
};
